import { useCallback } from 'react';

export const useDataManipulation = (data, onDataChange) => {
  const manipulateDataAtPath = useCallback((data, path, operation, value = null, key = null) => {
    if (path.length === 0) {
      switch (operation) {
        case 'update': return value;
        case 'add': return Array.isArray(data) ? [...data, ''] : { ...data, [key || `newKey${Object.keys(data).length + 1}`]: '' };
        default: return data;
      }
    }
    const [head, ...rest] = path;
    if (Array.isArray(data)) {
      const newArr = [...data];
      if (operation === 'remove' && rest.length === 0) {
        newArr.splice(head, 1);
      } else {
        newArr[head] = manipulateDataAtPath(data[head], rest, operation, value, key);
      }
      return newArr;
    } else if (typeof data === 'object' && data !== null) {
      if (operation === 'remove' && rest.length === 0) {
        const newObj = { ...data };
        delete newObj[head];
        return newObj;
      }
      return { ...data, [head]: manipulateDataAtPath(data[head], rest, operation, value, key) };
    }
    return data;
  }, []);

  const updateDataAtPath = useCallback((path, newValue, currentData = data) =>
    manipulateDataAtPath(currentData, path, 'update', newValue), [manipulateDataAtPath, data]);

  const addItemAtPath = useCallback((path, key = null) =>
    manipulateDataAtPath(data, path, 'add', null, key), [manipulateDataAtPath, data]);

  const removeItemAtPath = useCallback((path) =>
    manipulateDataAtPath(data, path, 'remove'), [manipulateDataAtPath, data]);

  return { updateDataAtPath, addItemAtPath, removeItemAtPath };
};
